import { connect } from 'react-redux';
import { VODCSSModules } from 'shared/utils/wix-connect';
import { isVisible } from 'widget/components/overlay-texts/channel/subscribe-button-text';
import ChannelSubscriptionLabel from './channel-subscription-label';

import { LinkButton } from 'shared/components/button/button';

import { getDealInfo } from 'shared/ui-selectors/channel/pricing';

import styles from './channel-actions.styl';


@connect((state, ownProps) => ({
  dealInfo: getDealInfo(ownProps),
  isVisible: isVisible({ channel: ownProps.channelData }),
}))
@VODCSSModules(styles)
export default class ChannelSubscriptionButton extends React.Component {

  static propTypes = {
    channelData: React.PropTypes.object,
    dealInfo: React.PropTypes.array,
    className: React.PropTypes.string,
    onClick: React.PropTypes.func,
    isVisible: React.PropTypes.bool,
  };

  render() {
    const { isVisible, dealInfo, className, onClick } = this.props;

    if (!isVisible) {
      return null;
    }

    return (
      <LinkButton className={`qa-channel-subscription ${className}`}
                  styleName="action subscribe"
                  onClick={onClick}>
        <ChannelSubscriptionLabel dealInfo={dealInfo}
                                  isVisible={isVisible} />
      </LinkButton>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/channel-actions/channel-subscription-button.js